import { ProjectAppsTab } from "@/components/projects/project-apps-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId/apps",
)({
	component: ProjectAppsTab,
});
